<template>
    <div class="contents">
      <div class="wrap">
        <section>
          <h2 class="page_title --view">첩약건보사전관리</h2>
          <article>
            <ul class="search_filter">
              <li>
                <p>기준처방코드</p>
                <input type="text" placeholder="출전을 입력하세요" class="form_control" v-model="searchInfo.standardPrescibeCd" @keyup.enter="fn_search">
              </li>
              <li>
                <p>방제명</p>
                <input type="text" placeholder="방제명을 입력하세요" class="form_control" v-model="searchInfo.dictionaryNm" @keyup.enter="fn_search">
              </li>
              <li>
                <p>질환구분</p>
                <div class="form_select">
                  <b-form-select v-model="searchInfo.nhisCategory" >
                    <b-form-select-option value="">선택</b-form-select-option>
                    <b-form-select-option v-for="(item, index) in NHIScategoryList" :key="index" :value="item.dtl_code">{{item.dtl_code_nm}}</b-form-select-option>
                  </b-form-select>
                </div>
              </li>
              <li>
                <p>처방유형</p>
                <div class="form_select">
                  <b-form-select v-model="searchInfo.nhisType" >
                    <b-form-select-option value="">선택</b-form-select-option>
                    <b-form-select-option v-for="(item, index) in NHISTypeList" :key="index" :value="item.dtl_code">{{item.dtl_code_nm}}</b-form-select-option>
                  </b-form-select>
                </div>
              </li>
              <li>
                <button class="btn btn_md btn_outline" @click="fn_search">조회</button>
              </li>
            </ul>
          </article>
        </section>
        <section class="view">
          <div class="table_list">
            <div class="table_option">
              <div class="form_select">
                <ul class="filter_kr">
                  <li v-for="(item, index) in filterKR" :key="index" 
                      :class="{ on:index === active}"
                      @click="active = index,fn_filter_click(index)"
                  >
                      {{ item }}
                  </li>
                </ul>
              </div>
              <div class="form_inline">
                <input type="file" ref="dictionaryExcelUpload" @change="fn_excel_read" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" hidden/>
                <button class="btn btn_md btn_outline"><i class="icon icon_excel" @click="fn_excel_upload_click"></i>Excel 업로드</button>
                <button class="btn btn_md btn_darkblue" @click="fn_move_reg_page">신규 등록</button>
              </div>              
            </div>
            <table class="list">
              <colgroup>
                <col width="300">
              </colgroup>
              <thead>
                <tr>
                    <th>기준처방코드</th>
                    <th>첩약건보사전명</th>
                    <th>첩약건보 질환구분</th>
                    <th>첩약건보 처방유형</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="dictionaryList.length == 0">
                    <td colspan="4"><span>데이터가 없습니다.</span></td>
                </tr>
                <tr v-for="(item, index) in dictionaryList" :key="index" @click="fn_move_dtl_page(item.insurance_dictionary_cd)">
                  <td><span>{{ item.standard_prescribe_cd }}</span></td>
                  <td class="al"><span>{{ item.insurance_dictionary_nm }}</span></td>
                  <td><span>{{ item.insurance_category_nm }}</span></td>
                  <td><span>{{ item.insurance_type_nm }}</span></td>
                </tr>
              </tbody>
            </table>
            <Pagination :pageInfo="searchInfo.pageInfo"  @clickPage="fn_movePage" v-show="pagingShow"/>
          </div>
        </section>
      </div>

    </div>
</template>

<script>

    import axios from 'axios'
    import commonUtil from "@/mixin/commonUtil";
    import Pagination from "@/components/AdminPagination.vue"
    import { read, utils } from 'xlsx'

  export default {
    name: 'insuranceMedicineMngt',
    components: {
      Pagination,
    },
    mixins: [commonUtil],
    data() {
      return {
        searchInfo : {
            dictionaryNm : '',
            standardPrescibeCd : '',
            nhisCategory : '',
            nhisType : '',
            filterIndex : '',            
            pageInfo : {
                page : 1,
                pageSize : 10,
                totPage : 0
            }              
        },
        pagingShow : false,
        dictionaryList: [],
        NHIScategoryList : [],
        NHISTypeList : [],
        selected: null,
        active: 0,
        filterKR:['전체','ㄱ','ㄴ','ㄷ','ㄹ','ㅁ','ㅂ','ㅅ','ㅇ','ㅈ','ㅊ','ㅋ','ㅌ','ㅍ','ㅎ']
      }
    },
    async created(){

          //공통코드 - 제조회사
          this.NHIScategoryList = await this.getCode('GC00000011'); 
          this.NHISTypeList = await this.getCode('GC00000012'); 

          let searchInfoStore = this.$store.getters['commonStore/getSearchInfo'];             
          if(searchInfoStore != null && searchInfoStore != {}){
              this.searchInfo = searchInfoStore
              this.active = this.searchInfo.filterIndex;
          }
        },
    mounted(){          
        this.fn_search();
    },
    methods : {
      fn_search(){
          console.log("@@@ search : ",this.searchInfo);

          this.$store.dispatch('commonStore/setSearchInfo', this.searchInfo); 

          axios
              .post("/api/admin/dictionary/getInsuranceDictionary", this.searchInfo)
              .then((res) => {

                  //첩약건보사전 리스트
                  this.dictionaryList = res.data.insuranceDictionaryList;
                  //첩약건보사전 리스트 총카운트
                  this.searchInfo.pageInfo.totPage = res.data.totCnt;
                  if(this.searchInfo.pageInfo.totPage> 0){
                      this.pagingShow = true;                          
                  }                        

              })
              .catch((err) => console.log(err));
      },
      fn_move_reg_page(){
          this.$store.dispatch('dictionary/setDictionaryCd', '');
          this.$store.dispatch('dictionary/setStatus', '');
          this.$router.push("/admin/dictionary/insuranceDictionaryMngtReg");
      },
      fn_filter_click(idx){
        this.searchInfo.filterIndex = idx;
        console.log("@@@@ this.filterIndex : "+this.searchInfo.filterIndex);
        this.fn_search();
      },
      fn_move_dtl_page(code){
            console.log("@@@@ dictionaryCd : "+code);
            this.$store.dispatch('dictionary/setDictionaryCd', code); 
            this.$router.push({ name : 'InsuranceDictionaryMngtDtl'});
      },
      fn_excel_upload_click(){
          let fileInputElement = this.$refs.dictionaryExcelUpload;
          fileInputElement.click();
      },
      fn_excel_read(event){
        console.log("@@@@@ fn_excel_read ");

        const file = event.target.files[0];
        let reader = new FileReader();
        
        reader.onload = (e) => {
            
            let data = reader.result;
            

            //type 종류: 'base64' | 'binary' | 'buffer' | 'file' | 'array' | 'string';
            const workbook = read(data, {type: 'binary'});

            workbook.SheetNames.forEach(sheetName  => {
              console.log("@@@@@ sheetName : %o",sheetName);

              if(sheetName == "첩약건보사전"){                                                             
                  workbook.Sheets[sheetName].A1.w = "excel_upload_prescribe_cd";
                  workbook.Sheets[sheetName].B1.w = "standard_prescribe_cd";
                  workbook.Sheets[sheetName].C1.w = "insurance_dictionary_nm";
                  workbook.Sheets[sheetName].D1.w = "insurance_category_nm";
                  workbook.Sheets[sheetName].E1.w = "insurance_type_nm";
                  workbook.Sheets[sheetName].F1.w = "limit_price";
                  
                  const roa = utils.sheet_to_json(workbook.Sheets[sheetName]);                       
                  
                  this.fn_excel_insurance_dictionary_upload(roa);     

              }else if(sheetName == "첩약건보사전약재"){

                  console.log("@@@@@ 여기요~");

                  workbook.Sheets[sheetName].A1.w = "excel_upload_prescribe_cd";
                  workbook.Sheets[sheetName].B1.w = "med_hrb_dtl_nm";
                  workbook.Sheets[sheetName].C1.w = "med_use_qnty";
          
                  const roa = utils.sheet_to_json(workbook.Sheets[sheetName]);   
                  
                  //console.log("@@@@@ roa : %o",roa);
                  
                  this.fn_excel_dictinary_med_upload(roa);  
              }
            });

            
                            
        };
        
        reader.readAsBinaryString(file);
        
      },
      fn_excel_insurance_dictionary_upload(uploadData){
        console.log("@@@@@ fn_excel_insurance_dictionary_upload : %o",uploadData);

        axios
          .post("/api/admin/dictionary/excelInsuranceDictionaryUpload", uploadData)
          .then((res) => {
              // alert("삭제되었습니다");
              // this.fn_dtl_search(medHrbCd);              
          })
          .catch((err) => console.log(err));


          this.$refs.dictionaryExcelUpload.values = {};

      },
      fn_excel_dictinary_med_upload(uploadData){

        console.log("@@@@@ fn_excel_dictinary_med_upload : %o",uploadData);

        axios
          .post("/api/admin/dictionary/excelInsuranceDictionaryMedUpload", uploadData)
          .then((res) => {
              // alert("삭제되었습니다");
              // this.fn_dtl_search(medHrbCd);
          })
          .catch((err) => console.log(err));

        this.$refs.dictionaryExcelUpload = null;

      },
      fn_movePage(page){
        this.searchInfo.pageInfo.page = page;
        this.fn_search();
      },
    },
  }
</script>